module.exports = require('./lib/noGetters');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-lazy-cache/noGetters.js
 ** module id = 932
 ** module chunks = 0
 **/